
  import { Vue } from "vue-class-component";
  
  export default class CloseInAppBrowser extends Vue {
    viewName = "CloseInAppBrowser";
  }
  